var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.status)?_c('span',{staticClass:"text-nowrap"},[_c('RunStatusIcon',{staticClass:"icon",attrs:{"status":_vm.status,"animated":_vm.animated}}),_vm._v(" "+_vm._s(_vm._f("capitalize")(_vm.status))+" ")],1):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }